'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactRouter = require('react-router');

var _reduxModulesSearch = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_reduxModulesSearch);

var _reduxModulesPosts = require('redux/modules/posts');

var postsActions = _interopRequireWildcard(_reduxModulesPosts);

var _components = {
  _$PostCategories: {
    displayName: 'PostCategories'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostList/PostCategories.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostList/PostCategories.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostCategories = (function (_Component) {
  _inherits(PostCategories, _Component);

  function PostCategories() {
    _classCallCheck(this, _PostCategories);

    _Component.apply(this, arguments);
  }

  PostCategories.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _props = this.props;
    var loadBySearch = _props.loadBySearch;
    var filter = _props.filter;
    var searchValue = nextProps.searchValue;

    clearTimeout(this.searchTimeout);

    if (searchValue.length > 0 && filter === nextProps.filter) {
      this.searchTimeout = setTimeout(function () {
        loadBySearch(searchValue);
      }, 350);
    }
  };

  PostCategories.prototype.isDefaultCategory = function isDefaultCategory(category) {
    return category === 'all';
  };

  PostCategories.prototype.isCategoryActive = function isCategoryActive(id) {
    var _props2 = this.props;
    var categoryActive = _props2.categoryActive;
    var searchActive = _props2.searchActive;

    if (categoryActive === id && !searchActive) {
      return ' is-active';
    }
    return '';
  };

  PostCategories.prototype.renderCategoriesNav = function renderCategoriesNav() {
    var _this = this;

    var _props3 = this.props;
    var categories = _props3.categories;
    var loading = _props3.loading;

    if (loading) {
      return '';
    }

    return _react2['default'].createElement(
      'nav',
      { className: 'posts-categories__nav animated fadeIn' },
      _react2['default'].createElement(
        'ul',
        { className: 'posts-categories__nav-list' },
        _react2['default'].createElement(
          'li',
          { className: 'posts-categories__nav-item', key: 'all' },
          _react2['default'].createElement(
            _reactRouter.Link,
            { to: '/', className: 'posts-categories__nav-link ' + this.isCategoryActive('all') },
            'All'
          )
        ),
        categories.map(function (category) {
          return _react2['default'].createElement(
            'li',
            { className: 'posts-categories__nav-item', key: category.id },
            _react2['default'].createElement(
              _reactRouter.Link,
              { to: '/' + category.slug, className: 'posts-categories__nav-link' + _this.isCategoryActive(category.slug) },
              category.name
            )
          );
        })
      )
    );
  };

  PostCategories.prototype.render = function render() {
    var _this2 = this;

    var _props4 = this.props;
    var activateSearch = _props4.activateSearch;
    var deactivateSearch = _props4.deactivateSearch;
    var updateSearch = _props4.updateSearch;
    var searchValue = _props4.searchValue;
    var load = _props4.load;
    var loadByCategory = _props4.loadByCategory;
    var categoryActive = _props4.categoryActive;
    var filter = _props4.filter;

    return _react2['default'].createElement(
      'div',
      { className: 'posts-categories' },
      _react2['default'].createElement(
        'div',
        { className: 'posts-categories__search', onClick: function () {
            _this2.refs.search.focus();
          } },
        _react2['default'].createElement(
          'svg',
          { className: 'posts-categories__search-icon icon icon--search', viewBox: '0 0 18 18' },
          _react2['default'].createElement('use', { xlinkHref: '#icon-search' })
        ),
        _react2['default'].createElement('input', { className: 'posts-categories__search-input', ref: 'search', type: 'text', value: searchValue, placeholder: 'Search by keyword',
          onChange: function (event) {
            updateSearch(event.target.value);
          },
          onFocus: function () {
            return activateSearch();
          },
          onBlur: function (event) {
            if (!event.target.value.length) {
              deactivateSearch();

              if (filter !== categoryActive) {
                if (!_this2.isDefaultCategory(categoryActive)) {
                  loadByCategory(categoryActive);
                } else {
                  load();
                }
              }
            }
          }
        })
      ),
      this.renderCategoriesNav()
    );
  };

  _createClass(PostCategories, null, [{
    key: 'propTypes',
    value: {
      categories: _react.PropTypes.array,
      loading: _react.PropTypes.bool,
      categoryActive: _react.PropTypes.string.isRequired,
      searchActive: _react.PropTypes.bool,
      searchValue: _react.PropTypes.string.isRequired,
      activateSearch: _react.PropTypes.func.isRequired,
      deactivateSearch: _react.PropTypes.func.isRequired,
      updateSearch: _react.PropTypes.func.isRequired,
      loadBySearch: _react.PropTypes.func.isRequired,
      loadByCategory: _react.PropTypes.func.isRequired,
      load: _react.PropTypes.func.isRequired,
      filter: _react.PropTypes.string
    },
    enumerable: true
  }]);

  var _PostCategories = PostCategories;
  PostCategories = _wrapComponent('_$PostCategories')(PostCategories) || PostCategories;
  PostCategories = _reactRedux.connect(function (state) {
    return {
      categories: state.categories.data,
      loading: state.categories.loading,
      categoryActive: state.categories.active,
      searchActive: state.search.active,
      searchValue: state.search.value,
      filter: state.posts.filter
    };
  }, function (dispatch) {
    return _redux.bindActionCreators(_extends({}, postsActions, searchActions), dispatch);
  })(PostCategories) || PostCategories;
  return PostCategories;
})(_react.Component);

exports['default'] = PostCategories;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PostList/PostCategories.js
// module id = 667
// module chunks = 0